




























import { defineComponent, PropType } from '@vue/composition-api';
import { GroupReportData } from '@front-app/services/CommunityApi/CommunityReportsApi';

export default defineComponent({
	components: {},
	props: {
		title: {
			type: String,
			required: true,
		},
		reportData: {
			type: Array as PropType<GroupReportData[]>,
			required: true,
		},
	},
	setup() {
		return {};
	},
});
